import { CampaignTypeDefinitions, MessageMedium } from 'modules/graphql/types';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { getMediumIcon, printCampaignLaunchDate } from 'modules/iterableGoals/utils';
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'ui/tooltip';
import { Truncate } from 'ui/utility/truncate';
import { colors } from 'ui/theme';
import { DATE_FORMAT_WITH_COMMA_HOUR_MINS, displayDate } from 'utils/date';
import { FlexColumn, SubText, SubTitleWrapper, TitleText } from './Styled';

type TitleProps = {
  campaignName: string;
  type: CampaignTypeDefinitions;
  messageMedium: MessageMedium;
  launchDate: string;
};

export const Title = ({ campaignName, type, messageMedium, launchDate }: TitleProps) => {
  const MediumIcon = getMediumIcon(messageMedium);
  const { t } = useGoalsTranslations();
  const [isTruncated, setIsTruncated] = useState(false);
  const titleRef = useRef<HTMLAnchorElement>(null);

  const campaignLaunchText = printCampaignLaunchDate(
    t,
    type,
    displayDate(launchDate, DATE_FORMAT_WITH_COMMA_HOUR_MINS),
  );

  useEffect(() => {
    if (titleRef.current) {
      setIsTruncated(titleRef.current.offsetWidth < titleRef.current.scrollWidth);
    }
  }, [titleRef.current]);

  return (
    <FlexColumn>
      <TitleText>
        <Tooltip isEnabled={isTruncated} tooltipContent={campaignName}>
          <Truncate ref={titleRef} maxWidth={450}>
            {campaignName}
          </Truncate>
        </Tooltip>
      </TitleText>
      <SubTitleWrapper>
        <MediumIcon color={colors.grey50} width={16} />
        <SubText>
          {messageMedium} • {campaignLaunchText}
        </SubText>
      </SubTitleWrapper>
    </FlexColumn>
  );
};
